import styled from 'styled-components'

import theme from '../../styles/theme'

export const Container = styled.div`

  p {
    position: absolute;
    font-size: 64px;
    line-height: 77px;
    font-weight: ${theme.fontSemibold};
    color: ${theme.white};
  }
`

export const IconWrapper = styled.div`
  width: 107px;
  height: 107px;
  display: flex;
  justify-content: center;
  align-items: center;
`
